module.exports = __webpack_public_path__ + "images/roo1-a8567b4c82.png";